<template>
  <div class="logistics-list">
    <Row>
      <Col :xs="24"
           :sm="24">

      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.keyword"
                 placeholder="快递名称..."
                 style="width: 260px;" />
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">筛选</Button>&nbsp;&nbsp;&nbsp;
          <Button @click="showModel()"
                  type="success">添加快递</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           title="添加快递"
           @on-ok="createBrand('logisValidate')"
           :loading="loading">
      <Form :model="logistic"
            ref="logisValidate"
            :rules="logisValidate"
            action="javascript:void(0)">
        <FormItem label="快递名称"
                  prop="name">
          <Input v-model="logistic.name"
                 placeholder="输入快递名称..."></Input>
        </FormItem>
        <FormItem label="快递编码"
                  prop="code">
          <Input v-model="logistic.code"
                 placeholder="输入快递编码..."></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改的弹出 -->
    <Modal v-model="showEditInfoStatus"
           title="修改快递"
           @on-ok="updateBrand('logisValidate')"
           :loading="loading">
      <Form :model="logistic"
            ref="logisValidate"
            :rules="logisValidate"
            action="javascript:void(0)">
        <FormItem label="快递名称"
                  prop="name">
          <Input v-model="logistic.name"
                 placeholder="输入快递名称..."></Input>
        </FormItem>
        <FormItem label="快递编码"
                  prop="code">
          <Input v-model="logistic.code"
                 placeholder="输入快递编码..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'logistics-list',
  data () {
    return {
      loading: true,
      dataloading: true,
      formItem: {
      },
      columns1: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '名称',
          key: 'name',
          fixed: 'left'
        },
        {
          title: '编码',
          key: 'code',
          fixed: 'left'
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showEditInfo(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      logistic: {
        name: '',
        code: '',
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      showModalStatus: false,
      showEditInfoStatus: false,
      logisValidate: {
        name: [
          { required: true, message: '快递名称必须填写', trigger: 'blur' }
        ]
      },
    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    getTableList: function () {
      var self = this;
      this.$api.logistics.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      let params = {
        page: this.pages.page,
        size: this.pages.size,
        keyword: this.formItem.keyword,
      };
      this.$api.logistics.list(params).then(res => {
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    },
    // 展开添加
    showModel () {
      this.$refs['logisValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createBrand (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api.logistics.create({ name: this.logistic.name, code: this.logistic.code }).then(res => {
            if (res.code == 200) {
              this.showModalStatus = !this.showModalStatus;
              this.logistic.name = '';
              this.getTableList();
            }
          });
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    //展开修改
    showEditInfo: function (index) {
      this.logisticid = index;
      this.$refs['logisValidate'].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.logistics.detail({ logistic_id: index }).then(res => {
        if (res.code == 200) {
          this.logistic = res.result;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => { this.loading = true; });
      });
    },
    // 修改名称
    updateBrand: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          console.log(this.logistic);
          this.$api.logistics.edit({ logistic_id: this.logisticid, name: this.logistic.name, code: this.logistic.code }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.showEditInfoStatus = !this.showEditInfoStatus;
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => { this.loading = true; });
            this.showCreateStatus = !this.showCreateStatus;
          });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.logistics.remove({ logistic_id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
  },
}
</script>
